import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import { createServiceWorkerUpdateCoordinator } from "./serviceWorkerUpdate";
import "./styles.css";

let activateWaitingWorker: (reloadPage?: boolean) => Promise<void> = async () => undefined;
const serviceWorkerUpdate = createServiceWorkerUpdateCoordinator({
  activateWaitingWorker: () => activateWaitingWorker(false),
  reload: () => window.location.reload(),
});
window.imprintServiceWorkerUpdate = serviceWorkerUpdate.handle;
// A worker activated by another tab may control us without this tab ever
// receiving the plugin's waiting event. First installation needs no reload.
if ("serviceWorker" in navigator) {
  let controller = navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    const previous = controller;
    controller = navigator.serviceWorker.controller;
    if (previous && controller !== previous) serviceWorkerUpdate.workerControlling();
  });
}
activateWaitingWorker = registerSW({
  immediate: true,
  onNeedRefresh: serviceWorkerUpdate.stage,
  onNeedReload: serviceWorkerUpdate.workerControlling,
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    let lastCheck = 0;
    const check = () => {
      if (!navigator.onLine || document.visibilityState !== "visible" || Date.now() - lastCheck < 60_000) return;
      lastCheck = Date.now();
      void registration.update().catch(() => undefined);
    };
    window.addEventListener("pageshow", check);
    window.addEventListener("online", check);
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    window.setInterval(check, 60 * 60_000);
    check();
  },
});

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
